import axios from 'axios';

import {UserAboutMeInfo} from 'types';

import {API_URL} from './constants';

const me = async (): Promise<UserAboutMeInfo> => {
    const res = await axios.get(`${API_URL}/about/me`);
    return res.data;
};

export const aboutApi = {
    me
};